import { axiosAPI } from './axios-instance';
import { ApiResponse } from './lib/types';

export type ApiGetCityListRequest = {
    query: string;
};

export type ApiGetCityListResponse = ApiResponse<
    {
        city: string;
    }[]
>;

export type AppGetCityListResponse = ApiGetCityListResponse;

export const GetCityList = (body: ApiGetCityListRequest): Promise<AppGetCityListResponse> =>
    axiosAPI.post<ApiGetCityListResponse>('/v1/dadata/city', body).then((res) => res.data);
